import {createSlice} from "@reduxjs/toolkit";
import {setUISiteFilter} from "./actions";

type SiteUIState = {
  [key: string]: {
    filter: {
      fromDttm: number,
      toDttm?: number
    }
  }
}

const INITIAL_STATE: Readonly<SiteUIState> = {};

const siteUISlice = createSlice({
  name: "ots-ui/site",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUISiteFilter,
      (state, {payload}) => {
        state[payload.id] = {
          ...(state[payload.id] ?? {}),
          filter: {
            fromDttm: payload.fromDttm,
            toDttm: payload.toDttm,
          }
        }
      }
    );
  }
});

export const siteUIReducer = siteUISlice.reducer;
